<template>
  <div>
    <div style="margin:0rem 0rem;padding: 0.5rem 0rem;background-color: white;"
      v-sticky="{ zIndex: 6, stickyTop: 56, className: 'sticky-buttons' }">
      <homeToggleFiltersJourney v-if="isToggleJourneyView" />
      <homeToggleFilters v-else />
    </div>

    <div v-if="!isToggleJourneyView">
      <div v-if="!isCreatedOrviewStories">
        <v-container v-if="!isSavedOrPublished">

          <v-row v-if="currentUserStoriesDraft.length>0">
            <v-col class="col-6 px-0 " v-for="(singleStory,i) in currentUserStoriesDraft" :key="singleStory.id">
              <stories :singleStory="singleStory" :currentArrayOfStories="currentUserStoriesDraft"
                :indexArrayOfStories="i" :isDraft="true" />
            </v-col>
          </v-row>
          <v-row v-else justify="center" align="center">
            <v-col class="col-9 px-0 mt-10 pb-0 pt-0">
              {{ $t("noStoriesFound") }}
            </v-col>
          </v-row>
        </v-container>

        <v-container v-else>
          <v-row v-if="currentUserStoriesPublished.length>0">
            <v-col class="col-6 px-0" v-for="(singleStory,i) in currentUserStoriesPublished" :key="singleStory.id">
              <stories :singleStory="singleStory" :currentArrayOfStories="currentUserStoriesPublished"
                :indexArrayOfStories="i" />
            </v-col>
          </v-row>
          <v-row v-else justify="center" align="center">
            <v-col class="col-9 px-0 mt-10 pb-0 pt-0">
              {{ $t("noStoriesFound") }}
            </v-col>
          </v-row>
        </v-container>
        <v-btn :disabled="readOnly==='true'?true:readOnly=='false'?false:readOnly" v-if="user.username!='Guest'"
          class="floatingBtn text-capitalize" medium color="primaryVariant" fixed bottom
          :style="{left: '50%', transform:'translateX(-50%)'}" @click="gotoCreateNewStoryContent()">
          <img style="width:1rem;margin-right:0.5rem" :src="require('@/assets/pencil.png')" />

          <span class="btncreatenewstory">{{ $t("create new Story")}}</span>
        </v-btn>
      </div>
      <div v-else>
        <v-container v-if="!isAllOrNearme">
          <v-row v-if="currentAllPublicStories.length>0">
            <v-col class="col-12 px-0" v-for="(singleStory,i) in currentAllPublicStories" :key="singleStory.id">
              <stories :singleStory="singleStory" :currentArrayOfStories="currentAllPublicStories"
                :indexArrayOfStories="i" />
            </v-col>
          </v-row>
          <v-row v-else justify="center" align="center">
            <v-col class="col-9 px-0 mt-10 pb-0 pt-0">
              {{ $t("noStoriesFound") }}
            </v-col>
          </v-row>
        </v-container>
        <v-container v-else>
          <v-row v-if="currentAllPublicNearMeStories.length>0">
            <v-col class="col-12 px-0 " v-for="(singleStory,i) in currentAllPublicNearMeStories" :key="singleStory.id">
              <stories :singleStory="singleStory" :currentArrayOfStories="currentAllPublicNearMeStories"
                :indexArrayOfStories="i" />
            </v-col>
          </v-row>
          <v-row v-else justify="center" align="center">
            <v-col class="col-9 px-0 mt-10 pb-0 pt-0">
              {{ $t("noStoriesFound") }}
            </v-col>
          </v-row>
        </v-container>
        <v-btn v-if="user.username!='Guest'" :disabled="readOnly==='true'?true:readOnly=='false'?false:readOnly"
          class="floatingBtn text-capitalize" medium color="primaryVariant" fixed bottom
          :style="{left: '50%', transform:'translateX(-50%)'}" @click="gotoCreateNewStoryContent()">
          <img style="width:1rem;margin-right:0.5rem" :src="require('@/assets/pencil.png')" />
          <span class="btncreatenewstory">{{ $t("create new Story")}}</span>
        </v-btn>
      </div>
    </div>

    <!-------JOURNEY SECTION---------->
    <div v-else>
      <div v-if="!isCreatedOrviewJourneys&&user.username!='Guest'">
        <v-container v-if="!isSavedOrPublishedJourneys" class="px-0 mt-15 pb-0 pt-0">
          <template v-if="currentUserJourneysDraft.length>0">
            <v-row @click="gotoSingleJoueneyView(item.id)" :key="item.id" v-for="(item) in currentUserJourneysDraft"
              justify="center" align="center" dark :class="'colorPalettejourney'+item.backgroundColor+' mt-0'">
              <template v-if="item.storiesArrayObjectIdDescription.length==0">
                <p>{{$t('journeyWithoutStories')}}</p>
              </template>
              <template v-else>
                <v-col col=12 class="px-0 mt-0 pb-0 pt-0 image-container" style="width:30%">
                  <div
                    v-if="(typeof item.storiesArrayObjectIdDescription[0].cover_image.media.formats!='undefined'&&item.storiesArrayObjectIdDescription[0].cover_image.media.formats!=null)">

                    <mediaFileStory
                      v-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.hasOwnProperty('coverImageCenter')"
                      :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.ext"
                      type="image" :isLocal="false">
                    </mediaFileStory>
                    <mediaFileStory
                      v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.hasOwnProperty('small')"
                      :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.ext"
                      type="image" :isLocal="false">
                    </mediaFileStory>
                    <mediaFileStory v-else
                      :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.ext"
                      type="image" :isLocal="false">
                    </mediaFileStory>

                  </div>
                </v-col>
              </template>
              <v-col cols="7" class="px-4 mt-0 pt-0 pb-0 mb-0">
                <v-row>
                  <v-col cols=12 class=" px-4 mt-0 pb-0 mb-0 pt-0">
                    <h4 class="mt-2 mb-0 pt-0 mb-0">{{item.journeyTitle}}</h4>
                  </v-col>
                  <v-col cols=12 class="px-4 mt-0 pb-0 mb-0 pt-0">
                    <p class="mt-0 mb-0 pt-0 mb-0">{{truncateJourneyDescription(item.journeyDescription)}}</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row>
              <v-col cols=12 class=" px-4 mt-0 pb-0 mb-0 pt-0">
                {{$t('noJourneyFound')}}
              </v-col>
            </v-row>
          </template>
        </v-container>
        <v-container v-else class="px-0 mt-15 pb-0 pt-0">
          <!--h2>getUserPublicJourney</h2-->
          <template v-if="currentUserJourneysPublished.length>0">
            <v-row @click="gotoSingleJoueneyView(item.id)" :key="item.id" v-for="(item) in currentUserJourneysPublished"
              justify="center" align="center" dark :class="'colorPalettejourney'+item.backgroundColor+' mt-0'">
              <template v-if="item.storiesArrayObjectIdDescription.length==0">
                <p>{{$t('journeyWithoutStories')}}</p>
              </template>
              <template v-else>
                <v-col col=12 class="px-0 mt-0 pb-0 pt-0 " style="width:30%">
                  <div>
                    <mediaFileStory
                      v-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.hasOwnProperty('coverImageCenter')"
                      :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.ext"
                      type="image" :isLocal="false">
                    </mediaFileStory>
                    <mediaFileStory
                      v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.hasOwnProperty('small')"
                      :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.ext"
                      type="image" :isLocal="false">
                    </mediaFileStory>
                    <mediaFileStory v-else
                      :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.ext"
                      type="image" :isLocal="false">
                    </mediaFileStory>
                  </div>
                </v-col>
              </template>

              <v-col cols="7" class="px-4 mt-0 pt-0 pb-0 mb-0">
                <v-row>
                  <v-col cols=12 class=" px-4 mt-0 pb-0 mb-0 pt-0">
                    <h4 class="mt-2 mb-0 pt-0 mb-0">{{item.journeyTitle}}</h4>
                  </v-col>
                  <v-col cols=12 class="px-4 mt-0 pb-0 mb-0 pt-0">
                    <p class="mt-0 mb-0 pt-0 mb-0">{{truncateJourneyDescription(item.journeyDescription)}}</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row>
              <v-col cols=12 class=" px-4 mt-0 pb-0 mb-0 pt-0">
                {{$t('noJourneyFound')}}
              </v-col>
            </v-row>
          </template>
        </v-container>
      </div>

      <div v-else>
        <v-container v-if="!isAllOrNearmeJourneys" class="px-0 mt-15 pb-0 pt-0">
          <!---------------------------------JOURNEY-------------------------------------------->

          <!---------------------------------->
          <!-------------------->

          <template v-if="currentallPublicJourneys.length>0">
            <span :key="item.id" v-for="(item) in currentallPublicJourneys">

              <v-row @click="gotoSingleJoueneyView(item.id)" v-if="item.storiesArrayObjectIdDescription.length==0" dark
                :class="'colorPalettejourney'+item.backgroundColor+' mt-0 mb-0 '">
              </v-row>


              <v-row @click="gotoSingleJoueneyView(item.id)" v-else-if="item.storiesArrayObjectIdDescription.length==1"
                dark :class="'colorPalettejourney'+item.backgroundColor+' mt-0'">

                <v-col cols=12 class=" px-5 mt-0 pb-0 mb-0 pt-0">
                  <h4 class="mt-2 mb-0 pt-0 mb-0">{{item.journeyTitle}}</h4>
                </v-col>
                <v-col cols=12 class="px-5 mt-2 pb-0 mb-0 pt-0">
                  <p class="mt-0 mb-0 pt-0 mb-0">{{truncateJourneyDescription(item.journeyDescription)}}</p>
                </v-col>
                <v-col col=12 align="center" class="px-0 mt-2 px-5  mb-2 pb-0 pt-0 ">
                  <mediaFileStory
                    v-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.hasOwnProperty('coverImageCenter')"
                    :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.ext"
                    type="image" :isLocal="false">
                  </mediaFileStory>
                  <mediaFileStory
                    v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.hasOwnProperty('small')"
                    :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.ext"
                    type="image" :isLocal="false">
                  </mediaFileStory>
                  <mediaFileStory v-else
                    :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.ext"
                    type="image" :isLocal="false">
                  </mediaFileStory>
                </v-col>
              </v-row>
              <v-row @click="gotoSingleJoueneyView(item.id)" v-else-if="item.storiesArrayObjectIdDescription.length>1"
                dark :class="'colorPalettejourney'+item.backgroundColor+' mt-0'">

                <v-col cols=12 class=" px-5 mt-0 pb-0 mb-0 pt-0">
                  <h4 class="mt-2 mb-0 pt-0 mb-0">{{item.journeyTitle}}</h4>
                </v-col>
                <v-col cols=12 class="px-5 mt-2 pb-0 mb-0 pt-0">
                  <p class="mt-0 mb-0 pt-0 mb-0">{{truncateJourneyDescription(item.journeyDescription)}}</p>
                </v-col>
                <v-col col=12 class="px-0 mt-2 px-5  mb-2 pb-0 pt-0 ">
                  <swiper class="swiper" :options="swiperOption">
                    <swiper-slide v-for="(singleStory, i) in item.storiesArrayObjectIdDescription"
                      :key="i+singleStory.id">
                      <mediaFileStory v-if="singleStory.cover_image.media.formats.hasOwnProperty('coverImageCenter')"
                        :mediaUrl="apiStrapi+'/uploads/'+singleStory.cover_image.media.formats.coverImageCenter.hash.replace(/ /g, '%20') + singleStory.cover_image.media.formats.coverImageCenter.ext"
                        type="image" :isLocal="false">
                      </mediaFileStory>
                      <mediaFileStory v-else-if="singleStory.cover_image.media.formats.hasOwnProperty('small')"
                        :mediaUrl="apiStrapi+'/uploads/'+singleStory.cover_image.media.formats.small.hash.replace(/ /g, '%20') + singleStory.cover_image.media.formats.small.ext"
                        type="image" :isLocal="false">
                      </mediaFileStory>
                      <mediaFileStory v-else
                        :mediaUrl="apiStrapi+'/uploads/'+singleStory.cover_image.media.formats.thumbnail.hash.replace(/ /g, '%20') + singleStory.cover_image.media.formats.thumbnail.ext"
                        type="image" :isLocal="false">
                      </mediaFileStory>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                  </swiper>
                </v-col>

              </v-row>
            </span>
          </template>
          <template v-else>
            <v-row>
              <v-col cols=12 class=" px-4 mt-0 pb-0 mb-0 pt-0">
                {{$t('noJourneyFound')}}
              </v-col>
            </v-row>
          </template>
        </v-container>
        <v-container v-else class="px-0 mt-15 pb-0 pt-0">
          <!--h2>{{$t("nearMeJourneys")}} currentAllPublicNearMeJourneys   </h2-->

          <!---------------------------------JOURNEY PLACEHOLDER--------------------------------------------->
          <template v-if="currentAllPublicNearMeJourneys.length>0">
            <span :key="item.id" v-for="(item) in currentAllPublicNearMeJourneys">

              <v-row @click="gotoSingleJoueneyView(item.id)" v-if="item.storiesArrayObjectIdDescription.length==0" dark
                :class="'colorPalettejourney'+item.backgroundColor+' mt-0 mb-0 '">
              </v-row>


              <v-row @click="gotoSingleJoueneyView(item.id)" v-else-if="item.storiesArrayObjectIdDescription.length==1"
                dark :class="'colorPalettejourney'+item.backgroundColor+' mt-0'">

                <v-col cols=12 class=" px-5 mt-0 pb-0 mb-0 pt-0">
                  <h4 class="mt-2 mb-0 pt-0 mb-0">{{item.journeyTitle}}</h4>
                </v-col>
                <v-col cols=12 class="px-5 mt-2 pb-0 mb-0 pt-0">
                  <p class="mt-0 mb-0 pt-0 mb-0">{{truncateJourneyDescription(item.journeyDescription)}}</p>
                </v-col>
                <v-col col=12 align="center" class="px-0 mt-2 px-5  mb-2 pb-0 pt-0 ">
                  <mediaFileStory
                    v-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.hasOwnProperty('coverImageCenter')"
                    :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.ext"
                    type="image" :isLocal="false">
                  </mediaFileStory>
                  <mediaFileStory
                    v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.hasOwnProperty('small')"
                    :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.ext"
                    type="image" :isLocal="false">
                  </mediaFileStory>
                  <mediaFileStory v-else
                    :mediaUrl="apiStrapi+'/uploads/'+item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.hash.replace(/ /g, '%20') + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.ext"
                    type="image" :isLocal="false">
                  </mediaFileStory>
                </v-col>
              </v-row>
              <v-row @click="gotoSingleJoueneyView(item.id)" v-else-if="item.storiesArrayObjectIdDescription.length>1"
                dark :class="'colorPalettejourney'+item.backgroundColor+' mt-0'">

                <v-col cols=12 class=" px-5 mt-0 pb-0 mb-0 pt-0">
                  <h4 class="mt-2 mb-0 pt-0 mb-0">{{item.journeyTitle}}</h4>
                </v-col>
                <v-col cols=12 class="px-5 mt-2 pb-0 mb-0 pt-0">
                  <p class="mt-0 mb-0 pt-0 mb-0">{{truncateJourneyDescription(item.journeyDescription)}}</p>
                </v-col>
                <v-col col=12 class="px-0 mt-2 px-5  mb-2 pb-0 pt-0 ">
                  <swiper class="swiper" :options="swiperOption">
                    <swiper-slide v-for="(singleStory, i) in item.storiesArrayObjectIdDescription"
                      :key="i+singleStory.id">
                      <mediaFileStory v-if="singleStory.cover_image.media.formats.hasOwnProperty('coverImageCenter')"
                        :mediaUrl="apiStrapi+'/uploads/'+singleStory.cover_image.media.formats.coverImageCenter.hash.replace(/ /g, '%20') + singleStory.cover_image.media.formats.coverImageCenter.ext"
                        type="image" :isLocal="false">
                      </mediaFileStory>
                      <mediaFileStory v-else-if="singleStory.cover_image.media.formats.hasOwnProperty('small')"
                        :mediaUrl="apiStrapi+'/uploads/'+singleStory.cover_image.media.formats.small.hash.replace(/ /g, '%20') + singleStory.cover_image.media.formats.small.ext"
                        type="image" :isLocal="false">
                      </mediaFileStory>
                      <mediaFileStory v-else
                        :mediaUrl="apiStrapi+'/uploads/'+singleStory.cover_image.media.formats.thumbnail.hash.replace(/ /g, '%20') + singleStory.cover_image.media.formats.thumbnail.ext"
                        type="image" :isLocal="false">
                      </mediaFileStory>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                  </swiper>
                </v-col>

              </v-row>
            </span>
          </template>
          <template v-else>
            <v-row>
              <v-col cols=12 class=" px-4 mt-0 pb-0 mb-0 pt-0">
                {{$t('noJourneyFound')}}
              </v-col>
            </v-row>
          </template>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Swiper,
  SwiperSlide
} from 'vue-awesome-swiper'
import 'swiper/swiper.min.css'
import mediaFileStory from "@/components/mediaFileStory.vue"
import VueSticky from 'vue-sticky' // Es6 module
//import modalfilter from "@/components/modalFilter.vue";
import stories from "@/components/storiesPreviewHome";
import homeToggleFilters from "@/components/homeToggleFilters";
import homeToggleFiltersJourney from "@/components/homeToggleFiltersJourney";

import {
  mapState
} from 'vuex';

export default ({
  name: 'home',

  data: () => ({
        swiperOption: {
      slidesPerView: 1.4,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    },
              apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
              //getUserDraftJourney:getUserDraftJourney,
              //getUserPublicJourney:getUserPublicJourney,
//getJourneyNearMejson:[],
    //getAllPublicJourney:getallPublicJourneyjson,


readOnly:process.env.VUE_APP_READONLY

  }),
  components: {
    Swiper,
    SwiperSlide,
    mediaFileStory,
    stories,
    homeToggleFilters,
    homeToggleFiltersJourney
    //modalfilter
  },
  directives: {
    'sticky': VueSticky,
  },
  // when I arrive on the page I check that the user is connected, otherwise I redirect him to the splashscreen
  created() {
    if (this.$store.getters.getAccessToken == null) {
      this.$router.push('splashScreen')
    }
  },
  //upon arrival on the page I download all the published stories and all the stories written by the logged in user
  //if it is the first time you arrive on the page you have to choose the filters
  mounted() {

//    this.$store.dispatch("setIsJourneyOrSingleStory", false)
 //   this.$store.dispatch("setSuggestionSearchText", '')
 //   this.$store.dispatch("setIsToggleSuggestionEnable", false)
//    this.$store.dispatch('setIsSuggestionLoading',false)
    this.$store.dispatch("setLoading",false)
    //clear temp information story - used for create or edit
    this.$store.dispatch("clearNewStory")
    this.$indexdb.mediaFiles.clear()

  },
  computed: {
      isToggleJourneyView: {
      get: function () {
        return this.$store.getters.getIsJourneyOrSingleStory;
      }
    },
    ...mapState(['user','currentUserJourneysPublished','currentUserJourneysDraft','currentAllPublicNearMeJourneys','currentallPublicJourneys','currentUserStoriesPublished','currentUserStoriesDraft','currentAllPublicNearMeStories','currentAllPublicStories','isCreatedOrviewStories', 'isAllOrNearme', 'isSavedOrPublished','isCreatedOrviewJourneys', 'isAllOrNearmeJourneys', 'isSavedOrPublishedJourneys', 'listOfSelectedTag', 'currenUserStoryFilter', 'dialogFilterTag'])
  },
  methods: {
    truncateJourneyDescription(value){
    let maxlength=160
    if (value.length<=maxlength)
    return value
     return value.substring(0,maxlength)

    },
    //change the page
    gotoCreateNewStoryContent: function () {
      this.$store.dispatch("clearNewStory").then(() => {
        this.$router.push({
          'name': 'createNewStoryContent'
        })
      })
    },
    gotoSingleJoueneyView: function (value) {
      this.$store.dispatch("clearNewStory").then(() => {
        this.$router.push({
          name: 'singleJourneyView',
          query: {idJourney:value}
        })
      })
    },
//---------------------------------
    gotoSingleStoryView: function (value) {
      this.$store.dispatch("clearNewStory").then(() => {
        this.$router.push({
          name: 'carouselForSingleStoryView',
          query: {idStory:value}
        })
      })
    }
  }
})
</script>

<style>
@media screen and (max-width: 600px) {
.pencilCreateNewStory{
width: 1rem;
}
  .image-container {
  max-width: 800px;
  max-height: 400px;
  overflow: hidden;
}

.image-container > .v-image  {
  width: 800px;
  height: 400px;
}
}
.pencilCreateNewStory{
width: 1rem;
}
  .image-container {
  max-width: 360px;
  max-height: 400px;
  overflow: hidden;
}

.image-container > .v-image  {
  width: 800px;
  height: 400px;
}
</style>
